<template>
    <div>
        <Header title="Professionell Sjukvårdsbemanning" :mobile_two_lines="true" :background="header_background" subtitle="Efter era behov, sedan 2007" />
        <table id="first">
            <tr>
                <td v-if="!mobile">
                    <div class="img_container">
                        <img src="../assets/img/pro_doc.jpg" />
                    </div>
                </td>
                <td>
                    <h1 class="underline">Ett glatt bemötande</h1>
                    <p>Vi står ut i mängden inte bara för att vi erbjuder en överlägsen service men för att vi gillar vårat jobb och därmed bemöter varje situation med ett glatt humör.</p>
                    <div class="good_things_list">
                        <table>
                            <tr>
                                <td>
                                    <i class="fas fa-graduation-cap"></i>
                                </td>
                                <td>
                                    <strong>Välutbildade och erfarna</strong>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <i class="fas fa-user-md"></i>
                                </td>
                                <td>
                                    <strong>Vänliga och respektfulla</strong>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <i class="fas fa-briefcase"></i>
                                </td>
                                <td>
                                    <strong>Redo för arbete</strong>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <p v-if="!mobile">Vill du bli en del av vår familj? Se våra <router-link to="/uppdrag">lediga uppdrag</router-link> här!</p>
                </td>
            </tr>
        </table>
        <div id="private_sector" v-if="!mobile">
            <h1>Gör karriär i den privata sektorn</h1><br><div class="border"></div><strong>Få bättre villkor med högre ersättning</strong>
        </div>
        <div id="benefits_circles" v-if="mobile">
            <div class="item">
                <div class="circle first"></div>
                <div class="text">Vi erbjuder dig bra arbete efter dina villkor</div>
            </div>
            <div class="item">
                <div class="circle second"></div>
                <div class="text">Hantera all din administration online</div>
            </div>
            <div class="item">
                <div class="circle third"></div>
                <div class="text">Vi är stolta som arbetsgivare, <router-link to="/information">läs mer</router-link> om vilka vi är</div>
            </div>
        </div>
        <div id="benefits_circles" v-else>
            <table width="100%">
                <tr>
                    <td>
                        <div class="item">
                            <div class="circle first"></div>
                            <div class="text">Vi erbjuder dig bra arbete efter dina villkor</div>
                        </div>
                    </td>
                    <td>
                        <div class="item">
                            <div class="circle second"></div>
                            <div class="text">Hantera all din administration online</div>
                        </div>
                    </td>
                    <td>
                        <div class="item">
                            <div class="circle third"></div>
                            <div class="text">Vi är stolta som arbetsgivare, <router-link to="/information">läs mer</router-link> om vilka vi är</div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div id="index_contact_section">
            <table>
                <tr>
                    <td>
                        <h1 class="underline">Du har allt att vinna</h1>
                        <p>Vi söker alltid god kompetens och erfarna medarbetare. <router-link to="/kontakta_oss">Kontakta oss</router-link> redan idag och se hur vi kan erbjuda dig bättre arbetsvillkor.</p>
                    </td>
                    <td v-if="!mobile">
                        <div class="contact_us"></div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import Footer from "./Footer";
    import Header from "./Header";
    import header_background from "../assets/img/demorris-byrd-K8RAfoZxoYI-unsplash.jpg";
    //import header_background from "../assets/img/hunters-race-408744-unsplash.jpg";

    export default {
        name: 'Home',
        components: {Header, Footer},
        data: function () {
            return {
                mobile: window.mobilecheck(),
                header_background: header_background
            };
        }
    }
</script>

<style scoped>
    @import url("../assets/css/home.module.css");
</style>